import React, { useContext, useEffect, useRef, useState } from "react";
import { useParams } from "react-router";
import EDCMainPanel from "../../Components/EDC/EDCMainPanel";
import CDISCManagementSidebar from "./CDISCManagementSidebar";
import ResizerXManager from "../../Components/ResizerXManager/ResizerXManager";
import { ResizableX, ResizableY } from "../Modules/ResizeTable/Layouts";
import Navbar from "../Navbar";
import Footer from "../Footer";
import { ResizablexContext } from "../Modules/ResizeTable/ResizeTable";
import CDISCDashboard from "./Dashboard/CDISCDashboard";
import FormLibraryManagement from "./FormLibraryManagement/FormLibraryManagement";
import FormDataManagement from "./FormDataManagement/FormDataManagement";
import CLookupManagement from "./CLookupManagement/CLookupManagement";
import StudyDetails from "./StudyManagement/StudyDetails";
import AuditTrial from "./StudyManagement/AuditTrial";
import SDAManagement from "./SDAManagement/SDAManagement";
import TrialDesignManagement from "./TrialDesignManagement/TrialDesignManagement";
import CMapManagement from "./CMapManagement/CMapManagement";
import TMapManagement from "./TMapManagement/TMapManagement";
import FinalDomain from "./FinalDomain/FinalDomain";
import S3DatasetManagement from "./FinalDomain/S3DatasetManagement";

const CDISCManagement = () => {
  const [studyTabs, setStudyTabs] = useState([]);
  const { studyId } = useParams();
  const [openModule, setOpenModule] = useState("cdiscMetadata");
  const [showSidebar, setShowSidebar] = useState(true);
  const [resizingColumn, setResizingColumn] = useState(null);
  const startX = useRef(0);
  const startWidth = useRef(0);
  const tableRef = useRef(null);
  const [collapseSidebar, setCollpaseSidebar] = useState(false);
  const [runOutput, setRunOutput] = useState(Math.floor(1000000000 + Math.random() * 9000000000));
  const resizableX = useContext(ResizablexContext);

  useEffect(() => {
    resizableX();
  });

  useEffect(() => {
    const onMouseMove = (e) => {
      if (resizingColumn !== null) {
        const width = startWidth.current + (e.pageX - startX.current);
        const th = tableRef.current.querySelector(
          `th:nth-child(${resizingColumn + 1})`
        );
        th.style.width = `${width}px`;
        tableRef.current.classList.add("resizing");
      }
    };

    const onMouseUp = () => {
      setResizingColumn(null);
      document.removeEventListener("mousemove", onMouseMove);
      document.removeEventListener("mouseup", onMouseUp);
    };

    if (resizingColumn !== null) {
      document.addEventListener("mousemove", onMouseMove);
      document.addEventListener("mouseup", onMouseUp);
    }

    return () => {
      document.removeEventListener("mousemove", onMouseMove);
      document.removeEventListener("mouseup", onMouseUp);
    };
  }, [resizingColumn]);

  const onMouseDown = (e, columnIndex) => {
    setResizingColumn(columnIndex);
    startX.current = e.pageX;
    startWidth.current = e.target.offsetWidth;
    document.body.style.userSelect = "none";
    tableRef.current.querySelectorAll("th").forEach((column, index) => {
      if (index !== columnIndex) {
        column.style.width = `${column.offsetWidth}px`;
      }
    });
  };

  const handleAddNewTab = (studyTabName, icon, studyTabId, idObject) => {
    let newTab = {
      studyTabId: studyTabId,
      studyTabName: studyTabName,
      icon: icon,
      openDT: new Date(),
      status: "active",
      idObject: idObject,
    };
    const updatedTabs = studyTabs?.map((studyTab) => ({
      ...studyTab,
      status: "inactive",
    }));
    const existTab = studyTabs?.some(
      (studyTab) => studyTab.studyTabId === studyTabId
    );
    if (existTab) {
      updatedTabs.forEach((element) => {
        if (element.studyTabId === studyTabId) {
          element.status = "active";
          element.studyTabName = studyTabName;
        }
      });
      setStudyTabs(updatedTabs || []);
    } else {
      setStudyTabs([...updatedTabs, newTab] || []);
    }
  };

  const checkActiveTab = (studyTabId) => {
    return studyTabs?.some(
      (item) => item.studyTabId === studyTabId && item.status === "active"
    );
  };

  const checkActiveMultiTab = (studyTabId) => {
    return studyTabs?.some(
      (item) => item.studyTabId?.includes(studyTabId) && item.status === "active"
    );
  };

  const checkActiveTabData = (studyTabId) => {
    return studyTabs?.find(
      (item) => item.studyTabId?.includes(studyTabId) && item.status === "active"
    );
  };

  const checkHomeActiveTab = () => {
    return studyTabs?.some((item) => item.status === "active");
  };

  const activeStudyTab = studyTabs?.some((item) => item.status === "active");

  useEffect(() => {
    const savedStudyTabs = JSON.parse(localStorage.getItem("studyTabs"));
    if (savedStudyTabs) {
      setStudyTabs(savedStudyTabs || []);
    }
  }, []);

  useEffect(() => {
    localStorage.setItem("studyTabs", JSON.stringify(studyTabs));
  }, [studyTabs]);

  return (
    <>
      <Navbar setOpenModule={setOpenModule} setShowSidebar={setShowSidebar} />
      <ResizableX>
        <div style={{ width: collapseSidebar ? 45 : 280 }}>
          <section className="middle-content">
            <CDISCManagementSidebar
              handleAddNewTab={handleAddNewTab}
              checkActiveTab={checkActiveTab}
              studyId={studyId}
              openModule={openModule}
              collapseSidebar={collapseSidebar}
              runOutput={runOutput}
            />
          </section>
        </div>
        <ResizerXManager collapseSidebar={collapseSidebar} />
        <ResizableY>
          <section className="middle-content " id="dashboard-section">
            <div className="inner-cont">
              <EDCMainPanel
                setStudyTabs={setStudyTabs}
                studyTabs={studyTabs}
                showSidebar={showSidebar}
                activeStudyTab={activeStudyTab}
                collapseSidebar={collapseSidebar}
                setCollpaseSidebar={setCollpaseSidebar}
              />
              {!checkHomeActiveTab() && <CDISCDashboard />}

              {checkActiveTab("formLibrary") && (
                <FormLibraryManagement
                  tableRef={tableRef}
                  onMouseDown={onMouseDown}
                />
              )}

              {checkActiveTab("cdiscSDA") && (
                <SDAManagement
                  tableRef={tableRef}
                  onMouseDown={onMouseDown}
                />
              )}

              {checkActiveTab("finalDomain") && (
                <FinalDomain
                  tableRef={tableRef}
                  onMouseDown={onMouseDown}
                  setRunOutput={setRunOutput}
                />
              )}

              {checkActiveTab("formDataLibrary") && (
                <FormDataManagement
                  tableRef={tableRef}
                  onMouseDown={onMouseDown}
                />
              )}

              {checkActiveTab("CLookup") && (
                <CLookupManagement
                  tableRef={tableRef}
                  onMouseDown={onMouseDown}
                />
              )}

              {checkActiveTab("CMap") && (
                <CMapManagement
                  tableRef={tableRef}
                  onMouseDown={onMouseDown}
                />
              )}

              {checkActiveTab("TMap") && (
                <TMapManagement
                  tableRef={tableRef}
                  onMouseDown={onMouseDown}
                />
              )}

              {checkActiveTab("trialDesignManagement") && (
                <TrialDesignManagement
                  tableRef={tableRef}
                  onMouseDown={onMouseDown}
                />
              )}

              {checkActiveTab("studyDetail") && <StudyDetails />}

              {checkActiveTab("auditLogs") && (
                <AuditTrial tableRef={tableRef} onMouseDown={onMouseDown} />
              )}
              
              {checkActiveMultiTab("resultLibrary") && (
                <S3DatasetManagement 
                tableRef={tableRef} 
                onMouseDown={onMouseDown}
                ids={checkActiveTabData("resultLibrary")?.idObject}
                />
              )}
            </div>
          </section>
        </ResizableY>
      </ResizableX>
      <Footer />
    </>
  );
};

export default CDISCManagement;
